import { Link } from "react-router-dom";
import { Pagination } from "@material-ui/lab";
import { useState } from "react";
import { useSelector } from "react-redux";
import "./movielist.css";
import { CircularProgress } from "@material-ui/core";

const MovieList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [moviePerPage] = useState(15);
  const [genre, setGenre] = useState("");
  const movies = useSelector(state => state.movie.movie);

  const indexOfLastMovie = currentPage * moviePerPage;
  const indexOfFirstMovie = indexOfLastMovie - moviePerPage;
  const currentMovies = movies.slice(indexOfFirstMovie, indexOfLastMovie);
  const movieByGenre = movies.filter(film => film.genre !== "genre");
  const totalPage = Math.ceil(movies.length / moviePerPage);

  return (
    <div className="container">
      <div className="movie-wrapper">
        <br />
        {currentMovies.length === 0 ? (
          <div style={{ marginRight: "50%", marginBottom: "50%" }}>
            <CircularProgress color="secondary" />
          </div>
        ) : (
          currentMovies.map(movie => (
            <div className="movie" key={movie._id}>
              <Link className="movie-link" to={`/detail_page/${movie._id}`}>
                <div className="card-movie-poster">
                  <img
                    src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
                  />
                </div>
                <div className="title">
                  <p>{movie.title}</p>
                </div>
              </Link>
            </div>
          ))
        )}
      </div>
      <div className="pagination">
        <div>
          <Pagination
            count={totalPage}
            onChange={(event, newPage) => setCurrentPage(newPage)}
            color="secondary"
            size="large"
          />
        </div>
      </div>
    </div>
  );
};

export default MovieList;
